// For react-stripe-elements
const fontSources = [{ cssSrc: 'https://fonts.googleapis.com/css?family=Montserrat:400' }]

export default fontSources
